import React, { useState, useEffect } from "react"
import _ from "lodash"

import { SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"
import { DropdownInput, NamedItemInput, NumberInput } from "components/table/carousel/inputs"
import { field_attrs } from "components/table/lib/column-field"
import inflationService from "data/inflation"

const MiscRevenueBasic = (props: {rowData: [], field: string, defaults: {}, namedItems: {}, persist: Function}) => {
  const emptyRecord = {
    amt: null,
    amtType: _.get(props, "defaults.miscRevenueAmtType"),
    inflation: {
      inflationNamedItemId: _.get(props, 'defaults.miscRevenueInflation.inflationNamedItemId', _.find(inflationService.value(), {code: '*None'})?.inflationid),
      inflationMode: 'namedItem'
    },
    effective: 'Lease Year'
  }
  const [data, setData] = useState<object|null>(props.rowData[props.field]);

  useEffect(() => {
    if (!props['rowData'][props.field] || props['rowData'][props.field].state !== 'basic') setData(emptyRecord)
  }, [props['rowData']])

  function updateData(val:any, field:string):void {
    let nextData    = _.cloneDeep(data)
    if (field.startsWith('inflation')){
      nextData['inflation']['inflationNamedItemId'] = val
    } else nextData[field] = val
    if (!nextData['amtType']) nextData['amtType']     = props.defaults['miscRevenueAmtType']
    if (!nextData['effective']) nextData['effective'] = props.defaults['effective']
    setData(nextData);
    props.persist({...nextData, state: 'basic'}, 'miscrevenuedetail', props.rowData)
  }

  const attrs = (field) => field_attrs('rentroll', props.field)(field)(props.rowData, props)

  return (
    <div>
      <SingleRowCarouselState_s>
        <div>
          <label>Amt</label>
          <NumberInput
            field="amt"
            className="automated billion-input"
            data={data}
            attrs={attrs}
            min={-2e9}
            max={2e9}
            readPrecision={4}
            writePrecision={4}
            persist={updateData}
          />
        </div>
        <div>
          <label>Amount Type</label>
          <DropdownInput
            field="amtType"
            className="automated"
            data={data}
            attrs={attrs}
            default={props.defaults['tiAmtType']}
            options={['/Mo', '/Yr', '/Area/Mo', '/Area/Yr']}
            persist={updateData}
          />
        </div>
        <div>
          <label>Inflation</label>
          <NamedItemInput
            className="automated named-item-state-input"
            data={data}
            attrs={attrs}
            field="inflation.inflationNamedItemId"
            filter={true}
            namedItem="inflationNamedItemId"
            options={props.namedItems['inflation'] || []}
            persist={updateData}
          />
        </div>
        <div>
          <label>Effective</label>
          <DropdownInput
            field="effective"
            className="automated"
            data={data}
            attrs={attrs}
            default='Lease Year'
            options={['Lease Year', 'Calendar Year', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']}
            persist={updateData}
          />
        </div>
      </SingleRowCarouselState_s>
    </div>
  )
}

export default MiscRevenueBasic
